import { PershingNumberFilter } from '../components/filters/pershing-number-filter.component';
import { HttpParams } from '@angular/common/http';

export class PershingGridUtil {

    /**
     * This is the primary static method for FSP filtering, used to append your filtering, sorting, and pagination query params
     * to the HttpParams. The HttpParams is returned, which can be used to your HttpClient calls.
     * @param queryParams
     * @param params
     */
    static getFSPFilterSortPaginationQueryParams(queryParams?: FilterSortPaginationParams, params?: HttpParams): HttpParams {

        let paramsFilterStr: string;
        let paramsSortFilter: string;
        let paramsPageNumber: string;
        let paramsPageSize: string;

        let paramsToReturn = new HttpParams();

        if (params) {
            if (params.has('filter')) {
                paramsFilterStr = params.get('filter');
            }

            if (params.has('sort')) {
                paramsSortFilter = params.get('sort');
            }

            if (params.has('page')) {
                paramsPageNumber = params.get('page');
            }

            if (params.has('pageSize')) {
                paramsPageSize = params.get('pageSize');
            }
        }

        if (queryParams) {
            if (queryParams.filterParams && queryParams.filterParams.length !== 0) {

                if (paramsFilterStr) {
                    let queryFilterParam = PershingGridUtil.getFSPFilterParams(queryParams.filterParams);
                    paramsFilterStr = (queryFilterParam !== '') ? (paramsFilterStr + ' AND ' + queryFilterParam) : paramsFilterStr;
                } else {
                    paramsFilterStr = PershingGridUtil.getFSPFilterParams(queryParams.filterParams);
                }
            }
            if (queryParams.sortParams && queryParams.sortParams.length !== 0) {
                paramsSortFilter = PershingGridUtil.getFSPSortParams(queryParams.sortParams);
            }
            if (queryParams.pageNumber && queryParams.pageSize) {
                paramsPageNumber = `${queryParams.pageNumber}`;
                paramsPageSize = `${queryParams.pageSize}`;
            }
        }

        if (paramsFilterStr) {
            paramsToReturn = paramsToReturn.append('filter', paramsFilterStr);
        }
        if (paramsSortFilter) {
            paramsToReturn = paramsToReturn.append('sort', paramsSortFilter);
        }
        if (paramsPageNumber) {
            paramsToReturn = paramsToReturn.append('page', paramsPageNumber);
        }
        if (paramsPageSize) {
            paramsToReturn = paramsToReturn.append('pageSize', paramsPageSize);
        }

        return paramsToReturn;
    }
    /**
     * Takes the ag-grid filter model and constructs the filter query param string
     * @param filterModel
     */
    static getFSPFilterParams(filterModel: any): string {
        let filterParams = [];
        for (let field in filterModel) {
            if (filterModel.hasOwnProperty(field)) {
                let value: PershingNumberFilter = filterModel[field];
                if (value.queryName) {
                    field = value.queryName;
                }
                if (value.filterType === 'number') {
                    filterParams.push(PershingGridUtil.getNumberFilterParams(field, value));
                }
            }
        }
        return filterParams.filter(element => element !== '').join(' AND ');
    }
    /**
     * Takes the ag-grid sort model and constructs the sort query param string
     * @param sortModel
     */
   static getFSPSortParams(sortModel: any): string {
        let sortParams = [];
        for (let colId in sortModel) {
            if (sortModel.hasOwnProperty(colId)) {
                let value = sortModel[colId];
                if (value) {
                    sortParams.push(PershingGridUtil.getFSPNumberSortParams(value.colId, value.sort));
                }
            }
        }
        return sortParams.filter(element => element !== '').join(',');
    }
    /**
     * Private method used to handle ascending and descending sort params
     * @param key
     * @param value
     */
    static getFSPNumberSortParams(key: any, value: any): string {
        return value + '(' + key + ')';
    }
    /**
     * This is the primary static method used to append your filtering, sorting, and pagination query params
     * to the HttpParams. The HttpParams is returned, which can be used to your HttpClient calls.
     * @param queryParams
     * @param params
     */
    static getFilterSortPaginationQueryParams(queryParams: FilterSortPaginationParams, params?: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }
        if (queryParams.filterParams && queryParams.filterParams.length !== 0) {
            params = params.append('filter', PershingGridUtil.getFilterParams(queryParams.filterParams));
        }
        if (queryParams.sortParams && queryParams.sortParams.length !== 0) {
            params = params.append('sort', encodeURIComponent(PershingGridUtil.getSortParams(queryParams.sortParams)));
        }
        if (queryParams.pageNumber && queryParams.pageSize) {
            params = params.append('page', `${queryParams.pageNumber}`);
            params = params.append('pageSize', `${queryParams.pageSize}`);
        }
        return params;
    }

    /**
     * Takes the ag-grid filter model and constructs the filter query param string
     * @param filterModel
     */
    static getFilterParams(filterModel: any): string {
        let filterParams = [];
        for (let field in filterModel) {
            if (filterModel.hasOwnProperty(field)) {
                let value: PershingNumberFilter = filterModel[field];
                if (value.queryName) {
                    field = value.queryName;
                }
                if (value.filterType === 'number') {
                    filterParams.push(PershingGridUtil.getNumberFilterParams(field, value));
                }
            }
        }
        return filterParams.filter(element => element !== '').join('&');
    }

    /**
     * Takes the ag-grid sort model and constructs the sort query param string
     * @param sortModel
     */
    static getSortParams(sortModel: any): string {
        let sortParams = [];
        for (let colId in sortModel) {
            if (sortModel.hasOwnProperty(colId)) {
                let value = sortModel[colId];
                if (value) {
                    sortParams.push(PershingGridUtil.getNumberSortParams(value.colId, value.sort));
                }
            }
        }
        return sortParams.filter(element => element !== '').join('&');
    }

    /**
     * Private method used to handle number filter params. Currently the only implementation for filter
     * @param key
     * @param value
     */
    private static getNumberFilterParams(key: any, value: any): string {
        // Example: tradeDateQuantity[eq]100
        // The type feld on the value is the operator (i.e. eq, lt, lte, gt, gte, etc.)
        return `${key}[${value.type}]${value.filter}`;
    }

    /**
     * Private method used to handle ascending and descending sort params
     * @param key
     * @param value
     */
    private static getNumberSortParams(key: any, value: any): string {
        let operation;
        switch (value) {
            case 'asc':
                operation = '+';
                break;
            case 'desc':
                operation = '-';
                break;
            default:
                break;
        }
        return (operation) ? operation + key : '';
       // return (operation) ? operation : key ;
    }

}

/**
 * Interface used to pass your filter, sort, and pagination criteria.
 */
export interface FilterSortPaginationParams {
    filterParams: any; // Filter Model
    sortParams: any; // Sort Model
    pageNumber: number;
    pageSize: number;
}
